import { motion } from "framer-motion";
import { ArrowRight, Crosshair } from "lucide-react";
import { scrollToId } from "@/lib/scroll";

export default function FinalCta() {
  return (
    <section className="relative bg-lima-navy px-5 md:px-10 py-16 md:py-36 overflow-hidden" data-testid="final-cta-section">
      <video
        ref={(el) => el && el.play().catch(() => {})}
        src="https://videos.pexels.com/video-files/36604691/15520313_640_360_25fps.mp4"
        poster="https://images.unsplash.com/photo-1612544409025-e1f6a56c1152?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzB8MHwxfHNlYXJjaHwxfHxjaW5lbWF0b2dyYXBoZXIlMjBmaWxtJTIwc2V0fGVufDB8fHx8MTc4ODAzMDI1Nnww&ixlib=rb-4.1.0&q=85"
        autoPlay
        muted
        loop
        playsInline
        className="absolute inset-0 w-full h-full object-cover opacity-15 saturate-[.5]"
        aria-hidden="true"
      />
      <div className="absolute inset-0 bg-lima-navy/70" aria-hidden="true" />
      <span
        className="hidden lg:block absolute left-6 top-1/2 -translate-y-1/2 font-mono2 text-[10px] tracking-[0.5em] text-white/25 [writing-mode:vertical-rl] rotate-180 select-none"
        aria-hidden="true"
      >
        LIM&nbsp;ACADEMY
      </span>
      <div className="relative max-w-6xl mx-auto grid lg:grid-cols-12 gap-12 items-center">
        <motion.div
          initial={{ opacity: 0, y: 40, filter: "blur(14px)" }}
          whileInView={{ opacity: 1, y: 0, filter: "blur(0px)" }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
          className="lg:col-span-7"
        >
          <p className="inline-flex items-center gap-3 font-mono2 text-xs md:text-sm tracking-[0.3em] text-lima-blue border border-lima-blue/50 px-3 py-1.5 mb-8">
            <Crosshair size={13} /> YOUR FIRST FRAME STARTS HERE
          </p>
          <h2 className="font-display font-bold text-5xl sm:text-6xl lg:text-7xl tracking-tight text-lima-paper leading-[1.0]">
            Ready to make
            <br />
            something <span className="font-serifit font-normal text-lima-blue">real?</span>
          </h2>
        </motion.div>
        <motion.div
          initial={{ opacity: 0, y: 40, filter: "blur(14px)" }}
          whileInView={{ opacity: 1, y: 0, filter: "blur(0px)" }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8, delay: 0.15, ease: [0.16, 1, 0.3, 1] }}
          className="lg:col-span-5"
        >
          <p className="text-sm md:text-base text-white/55 leading-relaxed mb-7">
            Applications for the next filmmaking and video production cohort are now open.
          </p>
          <motion.button
            whileTap={{ scale: 0.96 }}
            onClick={() => scrollToId("#contact")}
            data-testid="final-cta-button"
            className="bg-lima-blue hover:bg-lima-bluehover text-white font-mono2 text-xs font-bold tracking-[0.2em] px-8 py-4 transition-colors duration-200 inline-flex items-center gap-3"
          >
            REQUEST PROGRAM DETAILS <ArrowRight size={15} />
          </motion.button>
          <p className="mt-5 font-mono2 text-[11px] tracking-[0.15em] text-white/35">
            BATCH 01 · 15 SEATS · EMI AVAILABLE · SCHOLARSHIPS FOR EXCEPTIONAL APPLICANTS
          </p>
        </motion.div>
      </div>
    </section>
  );
}
